import React, { useContext, useEffect, useState } from 'react';
import { Card, Button, Form, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { admin_signin } from '../../Controller/actions';

import './signin.css';
import { NewContext } from '../../Context/NewContext';

const SignIn = ({ title }) => {
    const navigate = useNavigate();
    const [signInData, setSignInData] = useState({ email: "", password: "" });
    const { validated, setValidated } = useContext(NewContext);

    const handleChange = (e) => {
        setSignInData({ ...signInData, [e.target.name]: e.target.value });
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const form = e.currentTarget;
            if (form.checkValidity() === false) {
                e.preventDefault();
                e.stopPropagation();
                setValidated(true);
                toast.error("Invalid Credentials!")
            } else {
                // const { status, token, message } = await admin_signin(signInData);
                const { status, token, message } = await admin_signin(signInData);
                if (status) {
                    localStorage.setItem("token", token);
                    toast.success(message);
                    navigate("/dashboard");
                } else {
                    toast.error("Invalid Credentials!")
                    // toast.error(message);
                }
            }
        } catch (error) {
            console.error(error);
        };
    };

    useEffect(() => {
        document.title = `Emoji Keyboard | ${title}`
    }, [])

    return (
        // <div className='vh-100 d-flex justify-content-center align-items-center'>
        <Row className='signin-card-row vh-100 justify-content-center align-items-center g-0'>
            <Col xxl={4} xl={5} md={7} sm={11} className={`px-sm-0 px-3`}>
                <Card className='signin-card border-0'>
                    <Card.Header className='position-relative border-bottom-0 p-5'>
                        <div className='signin-card-header position-absolute bg-primary bg-gradient text-center p-4 m-auto shadow'>
                            <h2 className=' text-white'>Emoji Keyboard | Sign In</h2>
                        </div>
                    </Card.Header>
                    <Form noValidate validated={validated} method='post' onSubmit={handleSubmit}>
                        <Card.Body className='px-4'>
                            <Form.Group className='mb-3'>
                                <Form.Control size='lg' type="email" placeholder="Email" id="email" name="email" value={signInData.email} onChange={handleChange} required />
                            </Form.Group>
                            <Form.Group>
                                <Form.Control size='lg' type="password" placeholder="Password" id="password" name="password" value={signInData.password} onChange={handleChange} required />
                            </Form.Group>
                        </Card.Body>
                        <Card.Footer className='border-top-0 pt-4 pb-3 px-4'>
                            <Button size='lg' variant="primary" type="submit" className='w-100 text-uppercase bg-gradient'>Sign In</Button>
                        </Card.Footer>
                    </Form>
                </Card>
            </Col>
        </Row>
        // </div>
    )
};

SignIn.defaultProps = {
    title: "Sign In"
};

export default SignIn;